interface GroupContent {
  key: string;
  rows: readonly unknown[];
  unmapped: readonly unknown[];
}

// The demand groups the data-flow card offers: those with mapping rows or declared-but-
// unmapped features. A card with more than one gets tabs; with one, just that group's
// label. When neither group has anything, the first group (Demand Generation) still shows,
// so the card can say there's nothing mapped rather than render empty.
export const groupsToShow = <G extends GroupContent>(groups: G[]): G[] => {
  const withContent = groups.filter(g => g.rows.length > 0 || g.unmapped.length > 0);
  return withContent.length > 0 ? withContent : groups.slice(0, 1);
};

// The group the card shows: the selected tab when it's one of `shown`, otherwise the first
// shown group -- e.g. the default Demand Generation tab on a model with only Demand
// Capture features, or a tab left selected on a group that has none. `shown` is never
// empty (see groupsToShow).
export const activeShownGroup = <G extends { key: string }>(shown: G[], activeKey: string): G =>
  shown.find(g => g.key === activeKey) ?? shown[0];
